import React, { useEffect,useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/compat/router";
import { handleSignOut } from "@/helpers/userHelpers";
import { showCharityActiveMessage } from "@/redux/actions/generalAction";
import { isGuest, showPwaLoader } from "@/redux/actions/pwaAction";
import { openAccountSidebarFromPwaHeader } from "@/redux/actions/loggedInUser";
import { openAccountSidebar } from "@/redux/actions/loggedInUser";
import { setCookie } from "cookies-next";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";
import { useIsPreviewing } from "@builder.io/react";

const MyAccount = (props) => {
  const wishlist = useSelector((state) => state.wishlist.wishlist);
  const logedIn = useSelector((state) => state.loginUser);
  const [yotpo_points, setYotpoPoints] = useState();
  const [yotpo_tier_name, setYotpoTierName] = useState();
  const [yotpo_tier_image, setYotpoTierImage] = useState();
  const [yotpo_present, setYotpoPresent] = useState(false);
//alert(window.innerWidth)
  //window.innerWidth>=768 && window.innerWidth<=1024
  const isPWA = useSelector((state) => state.pwa.is_PWA);
  const dispatch = useDispatch();
  const isMobile = useMediaQuery("(max-width: 600px)");
  const isDesktop = useMediaQuery("(min-width: 1025px)");
  let numWishlistedItems = 0;
  if (wishlist) {
    numWishlistedItems = wishlist.length;
  }
  const { userName, styles, DashboardCloseRef, yotpoDetails} = props;
  const isPreviewing = useIsPreviewing(); //builder preview flag for impact content tile
  
  useEffect(() => {
    if(yotpoDetails?.yotpo_present) {
        setYotpoPresent(true);
        setYotpoPoints(yotpoDetails.points_balance)
        setYotpoTierName(yotpoDetails.vip_tier_name)
        setYotpoTierImage(yotpoDetails.yotpo_tier_image)
    } else {
        setYotpoPresent(false);
        setYotpoPoints()
        setYotpoTierName()
        setYotpoTierImage()
    }
  }, [yotpoDetails]);
  const router = useRouter();
  useEffect(() => {
    let ref = DashboardCloseRef?.current;
    
    if (ref) {
      ref.classList.add("mob_icon_close");
    }

    return () => {
      if (ref) {
        ref.classList.remove("mob_icon_close");
      }
    };
  }, [DashboardCloseRef]);

  useEffect(() => {
    if(!isMobile) {
      try {
          function scrollIntoViewIfNeeded(element) {
              const rect = element?.getBoundingClientRect();
              const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);

              // Check if the element is in the viewport
              if (rect.top < 0 || rect.top + rect.height > viewHeight - 200) {
                  element.scrollIntoView({
                      behavior: 'smooth',
                      block: 'center', // Scroll to the center of the element
                      inline: 'nearest'
                  });
              }
          }
        document.querySelectorAll('.account_menu_list.tab li').forEach(el => {
          el.addEventListener('keydown', function(event) {
            if (event?.key === 'Tab') {
                scrollIntoViewIfNeeded(this);
            }
          }, true);
        });
        // Add focus event listener to all elements that need scrolling
     }
     catch (e) {
      reportError("myaccountjs - scrollIntoViewIfNeeded function error");
      reportError(e)
     }
    }
  },); 

  
  return (
    <>
      <div className={`${styles.accountbar_content}`}>
        <h6
          className={`${styles.title} x-large-xs xx-large-sm xx-large-md light`}
        >
          My account
        </h6>
        {logedIn?.user_loggedIn && <div className={`${styles.heading}`}>
          <h5 className="normal-xs normal-sm large-md italic">Hello</h5>
          <h3
            className={`large-xs x-large-sm x-large-md light ${styles.account_name}`}
          >{`${userName ? userName.replace('N/A',"") : ""}`}</h3>
          {yotpo_present && <div className={`${styles.ytp_cutsomer_rank}`}>
            {yotpo_tier_image && <div className={`auto-acc-ytpTier-img ${styles.ytp_tier_img}`}>
            <img alt={yotpo_tier_name} src={yotpo_tier_image} />
            </div>}
            {yotpo_tier_name && <span className="small-md x-small-sm x-small-xs">{yotpo_tier_name}</span>}
            {yotpo_points && <span className="small-md x-small-sm x-small-xs">{yotpo_points}</span>}
          </div>}
          {props.impactMessage && (
            <div className={`auto-charity-section ${styles.charity_donation}`}>
              {props.charityLogo}
              <span
                className={`x-small-xs normal-md x-small-sm ${styles.donation_txt}`}
              >
                {props.impactMessage}
              </span>
            </div>
          )}
        </div>}
        <div className={`${styles.menu} ${(isPWA && logedIn?.user_loggedIn && isMobile) ? "account_menu_list_div_pwa":""}`}>
          <ul className={`account_menu_list ${isDesktop? 'tab' : ''} ${(isPWA && logedIn?.user_loggedIn && isMobile) ? "account_menu_list_pwa":""}`}>
            {logedIn?.user_loggedIn && <li className={`${isPWA?"app_ga_tracking":""}`}>
              <a
                className="small-xs small-sm normal-md exclude-pwa-loader"
                
                onClick={() => {
                  props.activeTab("ordersTab");
                }}
              >
                <span className={`${isPWA?"app_ga_tracking":""}`} tabIndex={0}>Orders</span>
              </a>
            </li>}
            <li className={`${isPWA?"app_ga_tracking":""}`}>
              <a
                href={`${process.env.LOOPRETURNS_STORE_DOMAIN}`}
                className="small-xs small-sm normal-md"
              >
                <span onClick={() => window?.ReactNativeWebView?.postMessage(JSON.stringify({ externalLink:true, link : `${process.env.LOOPRETURNS_STORE_DOMAIN}`}))} className={`${isPWA?"app_ga_tracking":""}`}>Returns</span>
              </a>
            </li>
            <li className={`nav_wishlist_menu ${styles.wishlist_menu} ${isPWA ? "app_ga_tracking":""}`}>
              <a
                className="small-xs small-sm normal-md exclude-pwa-loader"
                
                onClick={() => {
                  props.activeTab("myWishlistTab");
                }}
              >
                <span tabIndex={0} className={`${isPWA?"app_ga_tracking":""}`}>Wishlist</span>
              </a>
            </li>
            {logedIn?.user_loggedIn && <li>
              <a
                className={`exclude-pwa-loader small-xs small-sm normal-md ${isPWA ? 'app_ga_tracking' : ''}`}
                
                onClick={() => {
                  props.activeTab("myDetailsTab");
                }}
              >
                <span tabIndex={0} className={`${isPWA?"app_ga_tracking":""}`}>My details</span>
              </a>
            </li>}
            {(logedIn?.user_loggedIn || isPreviewing) && <li>
              <a             
                className={`exclude-pwa-loader small-xs small-sm normal-md ${isPWA ? 'app_ga_tracking' : ''}`}
                onClick={() => {
                  dispatch(showCharityActiveMessage(false))
                  props.activeTab("impactTab");
                }}
              >
                <span tabIndex={0} className={`${isPWA?"app_ga_tracking":""}`}>My impact</span>
              </a>
            </li>}
            <li className={`${isPWA?"app_ga_tracking":""}`}>
              <a
                className="small-xs small-sm normal-md"
                
                onClick={() => {
                  if(isPWA) {
                    dispatch(showPwaLoader(true))
                  }
                  window.location.href = "/rewards";
                }}
              >
                <span tabIndex={0} className={`${isPWA?"app_ga_tracking":""}`}>{logedIn?.user_loggedIn?"My rewards":"Rewards"}</span>
              </a>
            </li>
            {isPWA && <li className={`${isPWA?"app_ga_tracking":""}`}>
              <a
                className="small-xs small-sm normal-md"
                
                onClick={() => {
                  if(isPWA) {
                    dispatch(showPwaLoader(true))
                  }
                  window.location.href = "/boutique";
                }}
              >
                <span tabIndex={0} className={`${isPWA?"app_ga_tracking":""}`}>Boutique</span>
              </a>
            </li>}
            {isPWA && <li className={`${isPWA?"app_ga_tracking":""}`}>
              <a
                className="small-xs small-sm normal-md"
                onClick={(event) => {
                  event.preventDefault();
                  document.getElementById("INDmenu-btn").click(); 
                }}
              >
                <span tabIndex={0} className={`${isPWA?"app_ga_tracking":""}`}>Accessibility </span>
              </a>
            </li>}
            {isPWA && <li className={`${isPWA ? "app_ga_tracking":""}`}>
              <a
                className="small-xs small-sm normal-md exclude-pwa-loader"
                
                onClick={() => {
                  props.activeTab("helpTab");
                }}
              >
                <span tabIndex={0} className={`${isPWA?"app_ga_tracking":""}`}>Help</span>
              </a>
            </li>}
            {isPWA && logedIn?.user_loggedIn && <li className={`${isPWA?"app_ga_tracking":""}`}>
              <a
                className="small-xs small-sm normal-md" 
                onClick={() => {
                  handleSignOut();
                  //setting cookie to handle re-opening of account sidebar for OS-4181
                  setCookie("account_reopen", true);
                }}
              >
                <span tabIndex={0} className={`${isPWA?"app_ga_tracking":""}`}>Sign out</span>
              </a>
            </li>}
            {/* <li>
              <a
                className="small-xs small-sm normal-md"
                
                onClick={() => {
                  props.activeTab("addressListTab");
                }}
              >
                <span>Saved addresses</span>
              </a>
            </li>
            <li>
              <a  className="small-xs small-sm normal-md">
                <span>Payment methods</span>
              </a>
            </li>
            <li>
              <a  className="small-xs small-sm normal-md">
                <span>Gift cards & credit</span>
              </a>
            </li>
            <li>
              <a  className="small-xs small-sm normal-md">
                <span>Communication preferences</span>
              </a>
            </li> */}
          </ul>
        </div>
        {!isPWA && logedIn?.user_loggedIn && <div className={`${styles.button_footer}`}>
          <a
            onClick={()=>handleSignOut()}
            className={`${styles.button} btn-primary auto-logOut-btn`}
            tabIndex={0}
          >
            Sign out
          </a>
        </div>}
        {!logedIn?.user_loggedIn && <div className={`${styles.button_footer} ${isPWA?styles.pwa_footer:""}`}>
        <a
          onClick={
            (e)=>{
              e.preventDefault();
                // handleMobileAccountBar(true);
                //  if user using PWA and not using it for the first time then setting guest state to false
                dispatch(isGuest(false))
                dispatch(openAccountSidebarFromPwaHeader(false))
                dispatch(openAccountSidebar(true));
                setCookie('show_account_logout',true)
                //setting cookie to handle re-opening of account sidebar for OS-4181
                setCookie('account_reopen',true)
                // handleRoute("/account")
            }
          }
          className={`${styles.button} btn-primary auto-logOut-btn ${isPWA ? "app_ga_tracking":""}`}
          tabIndex={0}
        >Log in / register</a>
        </div>}
      </div>
    </>
  );
};

export default MyAccount;
